import React from "react";

const ColorPickerEmbed = () => (
  <div style={{ width: "100%", height: "80vh", minHeight: 600 }}>
    <iframe
      src="/color-picker/index.html"
      title="Color Picker"
      style={{ width: "100%", height: "100%", border: "none" }}
      allow="clipboard-write"
    />
  </div>
);

export default ColorPickerEmbed;
